// frontend/src/utils/AxiosErrorHandling.js

const fieldMap = {
    'identifier': 'شناسه کاربری',
    'password': 'رمز عبور',
    'new_password': 'رمز عبور جدید',
    'email': 'ایمیل',
    'phone_number': 'شماره تلفن',
    'full_name': 'نام و نام خانوادگی',
    'non_field_errors': 'خطای عمومی',
    'otp_code': 'کد تایید',
};

const messageMap = {
    'this field is required.': 'این فیلد الزامی است.',
    'user with this email already exists.': 'کاربری با این ایمیل قبلاً ثبت‌نام کرده است.',
    'user with this phone number already exists.': 'این شماره تماس قبلاً ثبت شده است.',
    'this password is too common.': 'این رمز عبور بسیار رایج است.',
    'invalid otp code.': 'کد تایید اشتباه است.',
};

export const handleAxiosAuthError = (error, context = 'general') => {
    // ۱. خطاهای شبکه
    if (error.code === 'ERR_NETWORK') throw new Error('خطای شبکه. اتصال اینترنت را بررسی کنید.');
    if (!error.response) throw new Error('ارتباط با سرور برقرار نشد.');

    const { status, data } = error.response;

    // ۲. محدودیت درخواست
    if (status === 429) throw new Error('تعداد درخواست‌ها زیاد است. کمی صبر کنید.');

    // ۳. اولویت ۱: خطاهای فیلد (مثل پسورد کوتاه یا تکراری)
    if (status === 400 && data && typeof data === 'object' && !Array.isArray(data)) {
        const firstField = Object.keys(data)[0];
        const fieldName = fieldMap[firstField] || fieldField;
        let msg = Array.isArray(data[firstField]) ? data[firstField][0] : data[firstField];

        if (typeof msg === 'string') {
            const isEnglish = /^[A-Za-z0-9\s.,!]+$/.test(msg);
            const translatedMsg = isEnglish ? (messageMap[msg.toLowerCase()] || msg) : msg;
            throw new Error(`${fieldName}: ${translatedMsg}`);
        }
    }

    // ۴. اولویت ۲: پیام‌های مستقیم (detail یا message)
    const directMsgRaw = data?.detail || data?.message;
    if (directMsgRaw) {
        const msg = Array.isArray(directMsgRaw) ? directMsgRaw[0] : directMsgRaw;
        if (typeof msg === 'string') {
            const isEnglish = /^[A-Za-z0-9\s.,!]+$/.test(msg);
            const translatedMsg = isEnglish ? (messageMap[msg.toLowerCase()] || msg) : msg;
            throw new Error(translatedMsg);
        }
    }

    // ۵. وضعیت‌های استاندارد
    if (status === 401) throw new Error('شناسه کاربری یا رمز عبور اشتباه است.');
    if (status >= 500) throw new Error('خطای فنی در سرور رخ داده است.');

    // ۶. پیام‌های جایگزین نهایی
    const fallbackMessages = {
        login: 'خطا در ورود. لطفاً اطلاعات خود را بررسی کنید.',
        register: 'خطا در ثبت‌نام. لطفاً فیلدها را با دقت پر کنید.',
        general: 'خطایی در عملیات رخ داده است. مجدداً تلاش کنید.'
    };

    throw new Error(fallbackMessages[context] || fallbackMessages.general);
};